import React from 'react'
import { TextField } from '@mui/material'
import { com } from '@eidu/form'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import Field = com.eidu.sharedlib.entity.field.Field

export type EntityFormTextInputProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
  updateField: (value: DraftFieldValue) => void
  error: boolean
}

const EntityFormTextInput = ({ field, fieldValue, updateField, error }: EntityFormTextInputProps) => (
  <TextField
    key={`field-${field.id.toString()}`}
    required={field.required}
    label={field.name}
    value={fieldValue?.value ?? ''}
    onChange={(event) => updateField({ fieldId: field.id, type: field.type, value: event.target.value })}
    error={error}
  />
)

export default EntityFormTextInput
